export const manifest = {
  screens: {
    scr_eo5ekk: { name: "Home", route: "/", position: {"x":160,"y":220} },
    scr_sk61te: { name: "Procedures", route: "/procedures", position: {"x":1560,"y":220} },
    scr_kc13wc: { name: "Procedure Detail", route: "/procedures/dental", position: {"x":2960,"y":220} },
    scr_gkprpb: { name: "Destinations", route: "/destinations", position: {"x":4360,"y":220} },
    scr_exl0v5: { name: "Destination Detail", route: "/destinations/mexico", position: {"x":5760,"y":220} },
    scr_ftyuai: { name: "How it works", route: "/how-it-works", position: {"x":160,"y":2200} },
    scr_26moa2: { name: "About", route: "/about", position: {"x":1560,"y":2200} },
    scr_z8v87y: { name: "FAQ", route: "/faq", position: {"x":2960,"y":2200} },
    scr_v1y2sw: { name: "Patient Guide", route: "/patient-guide", position: {"x":5760,"y":2200} },
    scr_6u4tpp: { name: "Contact", route: "/contact", position: {"x":4360,"y":2200} },
    scr_jjowsx: { name: "Facility Sign Up", route: "/partner-facility", position: {"x":160,"y":6160} },
    scr_m31p6t: { name: "Facilitator Sign Up", route: "/partner-facilitator", position: {"x":1560,"y":6160} },
    scr_tui0iw: { name: "Sitemap", route: "/sitemap", position: {"x":7160,"y":2200} },
    scr_rau3wy: { name: "Terms", route: "/terms", position: {"x":160,"y":4180} },
    scr_gg8aln: { name: "Privacy", route: "/privacy", position: {"x":1560,"y":4180} },
    scr_ihp1nr: { name: "Medical Disclaimer", route: "/medical-disclaimer", position: {"x":2960,"y":4180} },
    scr_6x8eqz: { name: "Accessibility Statement", route: "/accessibility-statement", position: {"x":4360,"y":4180} },
    scr_p37z60: { name: "Cookie Policy", route: "/cookie-policy", position: {"x":5760,"y":4180} },
    scr_219yu1: { name: "Hospitals", route: "/hospitals", position: {"x":160,"y":8140} },
    scr_lip6y6: { name: "Hospital Detail", route: "/hospitals/galenia-hospital-cancun", position: {"x":1560,"y":8140} },
    scr_qhokd3: { name: "Facilitators", route: "/facilitators", position: {"x":2960,"y":8140} },
    scr_gfvitj: { name: "Facilitator Detail", route: "/facilitators/border-health-connect", position: {"x":4360,"y":8140} },
  },
  sections: {
    sec_5uuu9o: { name: "Core User Journey", x: 0, y: 0, width: 7120, height: 1180 },
    sec_ihx7ag: { name: "Information & Support", x: 0, y: 1980, width: 8520, height: 1180 },
    sec_bhnfl2: { name: "Legal & Compliance", x: 0, y: 3960, width: 7120, height: 1180 },
    sec_yfzlh7: { name: "Partner Onboarding", x: 0, y: 5940, width: 2920, height: 1180 },
    sec_qcqmzr: { name: "Partner Directory", x: 0, y: 7920, width: 5720, height: 1180 },
  },
  layers: [
    { kind: "section", id: "sec_5uuu9o", children: [
      { kind: "screen", id: "scr_eo5ekk" },
      { kind: "screen", id: "scr_sk61te" },
      { kind: "screen", id: "scr_kc13wc" },
      { kind: "screen", id: "scr_gkprpb" },
      { kind: "screen", id: "scr_exl0v5" },
    ] },
    { kind: "section", id: "sec_ihx7ag", children: [
      { kind: "screen", id: "scr_ftyuai" },
      { kind: "screen", id: "scr_26moa2" },
      { kind: "screen", id: "scr_z8v87y" },
      { kind: "screen", id: "scr_6u4tpp" },
      { kind: "screen", id: "scr_v1y2sw" },
      { kind: "screen", id: "scr_tui0iw" },
    ] },
    { kind: "section", id: "sec_bhnfl2", children: [
      { kind: "screen", id: "scr_rau3wy" },
      { kind: "screen", id: "scr_gg8aln" },
      { kind: "screen", id: "scr_ihp1nr" },
      { kind: "screen", id: "scr_6x8eqz" },
      { kind: "screen", id: "scr_p37z60" },
    ] },
    { kind: "section", id: "sec_yfzlh7", children: [
      { kind: "screen", id: "scr_jjowsx" },
      { kind: "screen", id: "scr_m31p6t" },
    ] },
    { kind: "section", id: "sec_qcqmzr", children: [
      { kind: "screen", id: "scr_219yu1" },
      { kind: "screen", id: "scr_lip6y6" },
      { kind: "screen", id: "scr_qhokd3" },
      { kind: "screen", id: "scr_gfvitj" },
    ] },
  ],
}
